const belarusian = {
  default: [
    "ё ` 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
    "{tab} й ц у к е н г ш ў з х [ ] \\",
    "{lock} ф ы в а п р о л д ж э ; ' {enter}",
    "{shift} я ч с м і т ь б ю , . / {shift}",
    ".com @ {space}"
  ],
  shift: [
    "Ё ~ ! @ # $ % ^ & * ( ) _ + {bksp}",
    "{tab} Й Ц У К Е Н Г Ш Ў З Х { } |",
    '{lock} Ф Ы В А П Р О Л Д Ж Э : " {enter}',
    "{shift} Я Ч С М І Т Ь Б Ю < > ? {shift}",
    ".com @ {space}"
  ]
};

export default belarusian;
